import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface KeyboardHelpProps {
  open: boolean;
  onClose: () => void;
}

// (key, actionKey) tuples. The actionKey is a translation key suffix under
// `dashboard:keyboardHelp.actions`; the key chord itself is intentionally
// not translated.
const shortcuts: ReadonlyArray<readonly [string, string]> = [
  ["1", "focusLeft"],
  ["2", "focusRight"],
  ["/", "focusSearch"],
  ["s", "swap"],
  ["f", "fullscreen"],
  ["j", "next"],
  ["k", "prev"],
  ["Enter", "expand"],
  ["Esc", "close"],
  ["m", "mute"],
  ["r", "refresh"],
  ["?", "showHelp"],
];

export function KeyboardHelp({ open, onClose }: KeyboardHelpProps) {
  const { t } = useTranslation("dashboard");
  return (
    <Dialog open={open} onOpenChange={(value) => { if (!value) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("keyboardHelp.title")}</DialogTitle>
        </DialogHeader>
        <table className="w-full">
          <tbody>
            {shortcuts.map(([key, actionKey]) => (
              <tr key={key} className="border-b border-border last:border-0">
                <th scope="row" className="text-start px-2 py-1.5 w-20">
                  <kbd className="inline-block rounded border border-border bg-muted px-1.5 py-0.5 text-xs font-mono">
                    {key}
                  </kbd>
                </th>
                <td className="px-2 py-1.5 text-sm">
                  {t(`keyboardHelp.actions.${actionKey}`)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
